import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useTitle } from "src/hooks/use-title";
import { TranslationKey } from "src/types/i18next";

export const MainRoute = ({
  title,
  component,
}: {
  title: TranslationKey;
  component: ReactNode;
}) => {
  const { t } = useTranslation();
  useTitle(t(title));

  return component;
};